import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=8e0cb676&scoped=true&"
import script from "./DeliveryTable.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTable.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTable.vue?vue&type=style&index=0&id=8e0cb676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0cb676",
  null
  
)

export default component.exports